export default __webpack_public_path__ + "static/media/VideoDefault.f4c85808.svg";